export default __webpack_public_path__ + "longshot-logo.682540ab.svg";